import { withNaming } from '@bem-react/classname';

const bemClassName = withNaming({ n: '', e: '__', m: '--' });

export default bemClassName;
